import LayerGroup from 'ol/layer/Group';
import TileLayer from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS';
import { urlWMSInundaciones, formatoPNG } from './configuracion';

const layer00433 = new TileLayer({
  title: 'Máscara 19840910',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19840910l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00433.setVisible(false);

const layer00432 = new TileLayer({
  title: 'Máscara 19841012',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19841012l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00432.setVisible(false);

const layer00431 = new TileLayer({
  title: 'Máscara 19841231',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19841231l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00431.setVisible(false);

const layer00430 = new TileLayer({
  title: 'Máscara 19850201',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19850201l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00430.setVisible(false);

const layer00429 = new TileLayer({
  title: 'Máscara 19850305',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19850305l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00429.setVisible(false);

const layer00428 = new TileLayer({
  title: 'Máscara 19850609',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19850609l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00428.setVisible(false);

const layer00427 = new TileLayer({
  title: 'Máscara 19850812',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19850812l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00427.setVisible(false);

const layer00426 = new TileLayer({
  title: 'Máscara 19850828',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19850828l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00426.setVisible(false);

export const grupoCapa01_37 = new LayerGroup({
  title: 'Ciclo Hidrológico 1984-1985',
  fold: 'close',
  layers: [layer00426, layer00427, layer00428, layer00429, layer00430, layer00431, layer00432, layer00433]
});